module.exports = {"513424100":"德州镇","513424101":"永郎镇","513424102":"乐跃镇","513424103":"麻栗镇","513424104":"阿月镇","513424105":"六所镇","513424106":"茨达镇","513424107":"小高镇","513424108":"王所镇","513424109":"巴洞镇","513424110":"宽裕镇","513424208":"锦川乡","513424209":"老碾乡","513424210":"大湾乡","513424211":"马安乡","513424212":"铁炉乡","513424214":"大山乡","513424215":"大六槽乡","513424216":"热河乡","513424217":"南山傈僳族乡","513424218":"金沙傈僳族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513424.json
// module id = 2247
// module chunks = 0